import { useEffect, useRef } from 'react';

const useDocumentTitle = (title, options = {}) => {
  const {
    prefix = '',
    suffix = 'Hotel Manager',
    separator = ' | ',
    notifications = 0,
    isError = false
  } = options;

  // Keep track of the previous title
  const previousTitle = useRef(document.title);

  useEffect(() => {
    // Store the current title at the start of the effect
    const currentTitle = document.title;
    
    // Build the title parts
    const titleParts = [];

    // Add notification count if any
    if (notifications > 0) {
      titleParts.push(`(${notifications})`);
    }

    // Add prefix if provided
    if (prefix) {
      titleParts.push(prefix);
    }

    // Add main title if provided
    if (title) {
      titleParts.push(title);
    }

    // Add error indicator if needed
    if (isError) {
      titleParts.push('Error');
    }

    // Always add the app name (suffix) at the end
    titleParts.push(suffix);

    // Combine all parts with separator, filtering out empty strings
    const newTitle = titleParts.filter(Boolean).join(separator);

    // Update the document title
    document.title = newTitle;

    // Store the title we're setting for the cleanup function
    previousTitle.current = currentTitle;

    // Cleanup function uses the stored title
    return () => {
      document.title = currentTitle;
    };
  }, [title, prefix, suffix, separator, notifications, isError]);
};

export default useDocumentTitle; 